/* eslint-disable @typescript-eslint/no-explicit-any -- these helpers map
   dynamically-shaped Supabase project/ticket rows and SSE JSON. */
/**
 * AIC-2.3 pure helpers for the assistant transport, split out from
 * aiChatService so they're unit-testable without the supabase client.
 */

/** Parse one SSE "data: {json}" block from the ai-chat stream. */
export function parseSSEEvent(block: string): Record<string, any> | null {
  const line = block.trim();
  if (!line.startsWith('data:')) return null;
  try {
    return JSON.parse(line.slice(line.indexOf('data:') + 5).trim());
  } catch {
    return null;
  }
}

/**
 * Trim RLS-gathered project/ticket data into a compact `live_data` payload for
 * the backend (which renders it in the volatile tail). Returns null when there
 * is nothing relevant, so the backend omits the section.
 */
export function buildLiveData(
  projects: any[] | null,
  tickets: any[] | null,
  isFollowUp: boolean,
): Record<string, any> | null {
  const data: Record<string, any> = {};
  if (projects && projects.length > 0) {
    data.projects = projects.slice(0, 10).map((p: any) => ({
      name: p.project_name,
      company: p.company_name || null,
      city: p.project_city || null,
      state: p.project_state || null,
      stage: p.stages?.name || null,
      pipeline: p.pipelines?.name || null,
      total_tasks: p.total_tasks || 0,
      pending_tasks: (p.pending_tasks || []).slice(0, 5).map((t: any) => ({
        title: t.title, status: t.status, due: t.due_date || null,
      })),
      urgent_tasks: (p.urgent_tasks || []).slice(0, 5).map((t: any) => ({
        title: t.title, priority: t.priority, due: t.due_date || null,
      })),
      incomplete_checklist_count: p.incomplete_checklist_count || 0,
      outstanding_checklist: (p.incomplete_checklists || [])
        .slice(0, 8).map((i: any) => i.template_item?.item_name).filter(Boolean),
    }));
  }
  if (tickets && tickets.length > 0) {
    data.tickets = tickets.slice(0, 10).map((t: any) => ({
      number: t.ticket_number,
      title: t.title,
      status: t.status || null,
      priority: t.priority || null,
      category: t.category || null,
    }));
  }
  if (!data.projects && !data.tickets) return null;
  if (isFollowUp) data.note = 'This is a follow-up about the items previously discussed.';
  return data;
}
